@if (erro(); as mensagem) {
    <div class="arquivados-feedback erro" role="alert">{{ mensagem }}</div>
} @else if (carregando()) {
    <div class="arquivados-feedback" role="status" aria-live="polite">Carregando protocolos arquivados...</div>
} @else if (vazio()) {
    <div class="arquivados-feedback">
        @if (numeroBusca() !== undefined) {
            Nenhum protocolo encontrado com o número {{ numeroBusca() }}. A busca no arquivo é por número exato — confira se digitou o protocolo completo.
        } @else {
            Nenhum protocolo arquivado.
        }
    </div>
} @else {
    <app-custom-table
        [metadata]="metadataTabela"
        [data]="linhas()"
        [totalRecords]="total()"
        [rows]="linhasPorPagina()"
        [first]="primeiraLinha()"
        [initialViewMode]="'table'"
        [showViewSwitcher]="false"
        [showExpandButton]="false"
        [showActions]="false"
        [rowClickable]="true"
        (onPageChange)="aoTrocarPagina($event)"
        (onRowClick)="aoSelecionar($event)"
    >
        <!--
            `showViewSwitcher=false`: o cartão declarativo do CustomTable renderiza por tipo e NÃO
            passa por este `pTemplate` — com a célula sob medida abaixo, ele imprimiria o objeto do
            perfil como texto. O arquivo é tela de consulta por protocolo, e a tabela densa é o que
            serve; um cartão próprio, como o da Central, seria um segundo desenho da mesma linha.

            Única coluna sob medida: o badge do protocolo fica ACIMA do nome, e o tipo `perfil` do
            CustomTable desenha só retrato e nome. As demais colunas saem do metadata.
        -->
        <ng-template pTemplate="cell" let-rowData="rowData" let-column="column">
            @switch (column.key) {
                @case ('solicitantePerfil') {
                    <app-identificacao-pessoa
                        [foto]="rowData.solicitantePerfil?.foto ?? null"
                        [iniciais]="rowData.solicitantePerfil?.iniciais ?? null"
                        [nome]="rowData.solicitantePerfil?.nome || metadataTabela.headers['solicitantePerfil'].default"
                        [protocolo]="rowData.portal"
                        [inscricao]="rowData.inscricao"
                        [rotuloRetrato]="rowData.rotuloRetrato"
                    />
                }
            }
        </ng-template>
    </app-custom-table>
}
